module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/symbol-observable/index.js
// module id = 492
// module chunks = 0 3 5